module.exports = __webpack_public_path__ + "step3.0c0f4ed33a1d75a59859226eb7270435.png";